import { ButtonHTMLAttributes, MouseEventHandler, ReactNode } from "react";
import { useFormContext } from "react-hook-form";
import styled from "styled-components";


type Props = {
  text?: string;
  children?: ReactNode;
  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
  btnStyle?: "primary" | "disabled";
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  customSize?: { width: string; height: string };
  width?: string;
  height?: string;
  backgroundColor?: string;
  textColor?: string;
};

export const Button: React.FC<Props> = ({
  text,
  children,
  type = "button",
  btnStyle = "primary",
  onClick,
  disabled,
  customSize,
  width,
  height,
  backgroundColor,
  textColor,
}) => {
  const formContext = useFormContext();

  return (
    <StyledButton
      type={type}
      $btnStyle={btnStyle}
      onClick={onClick}
      $customSize={customSize}
      $width={width}
      $height={height}
      disabled={
        type === "submit"
          ? !formContext?.formState.isValid ||
          formContext?.formState.isSubmitting
          : disabled
      }
      $backgroundColor={backgroundColor}
      $textColor={textColor}
    >
      {children || text}
    </StyledButton>
  );
};

const StyledButton = styled.button<{
  $btnStyle?: "primary" | "disabled";
  $customSize?: { width: string; height: string };
  $width?: string;
  $height?: string;
  $backgroundColor?: string;
  $textColor?: string;
}>`
  background: ${({ $backgroundColor }) => $backgroundColor || "#a9c3e8"};
  color: ${({ $textColor }) => $textColor || "#18145a"};
  border: none;
  font-size: 18px;
  font-weight: 600;
  line-height: 1em;
  letter-spacing: 0;
  padding: 0px 5px;
  width: ${({ $customSize, $width }) =>
    $customSize?.width || $width || "240px"};
  height: ${({ $customSize, $height }) =>
    $customSize?.height || $height || "70px"};
  border-radius: 8px;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
